'use strict';

/*global isEmpty*/

function K2Keyboard(keyboardId) {
  this.keyboardId = keyboardId || 'k2-keyboard';
  this.layout = 'numeric';
  this.keyboardLayout = null;

  this.numericLayout = {
    btn1: { code: [97], title: '1' },
    btn2: { code: [98], title: '2' },
    btn3: { code: [99], title: '3' },
    btn4: { code: [100], title: '4' },
    btn5: { code: [101], title: '5' },
    btn6: { code: [102], title: '6' },
    btn7: { code: [103], title: '7' },
    btn8: { code: [104], title: '8' },
    btn9: { code: [105], title: '9' },
    btn10: { code: [96], title: '0' },
    btn11: { code: [110], title: '.' },
    btn12: { code: [109], title: '-' },
    btnCE: { code: [46], title: 'CE' },
    btnSpace: { code: [32], title: '___' }
  };

  this.alphabetLayout = {
    btn1: { code: [65, 66, 67], title: 'abc' },
    btn2: { code: [68, 69, 70], title: 'def' },
    btn3: { code: [71, 72, 73], title: 'ghi' },
    btn4: { code: [74, 75, 76], title: 'jkl' },
    btn5: { code: [77, 78, 79], title: 'mno' },
    btn6: { code: [80, 81, 82, 83], title: 'pqrs' },
    btn7: { code: [84, 85, 86], title: 'tuv' },
    btn8: { code: [87, 89, 90, 91], title: 'wxyz' },
    btn9: { code: [0, 0, 0, 0, 0], title: '/:,?!' },
    btn10: { code: [0, 109], title: '_-' },
    btn11: { code: [110], title: '.' },
    btn12: { code: [32], title: ' ' },
    btnCE: { code: [46], title: 'CE' },
    btnSpace: { code: [32], title: '___' },
    btnBackspace: { code: [0], title: '<--' },
    btnShift: { code: [0], title: 'a..z / A..Z' },
    btnSwitch: { code: [0], title: '1..9 / a..z' }
  };

  this.customButtons = {};

  this.$keyboardInput = null;
  this.$keyboardInputWrapper = null;
  this.$keyboardCustomInput = null;
  this.$keyboard = null;

  this.confirmTimeout = null;
  this.confirmDelay = 700;
  this.lastClickedButton = null;
  this.lastClickedButtonIndex = -1;

  this.isShiftActivated = false;
  this.isAllowedSwitchLayout = false;
  this.isAllowedAppendCustomButtonValue = true;
  this.isAllowedSpace = false;

  this.init();
}

K2Keyboard.prototype = $.extend({}, {
  constructor: 'Keyboard',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#' + _this.keyboardId + ' .k2-keyboard__btn', function () {
      _this.buttonDown($(this));
      return false;
    });

    $('body').on('keydown', function (e) {
      if (_this.$keyboard && _this.$keyboard.is(':visible')) {
        if ((_this.$keyboardInput.hasClass('has-focus') && !_this.$keyboardInput.is(':focus')) || (_this.$keyboardCustomInput && _this.$keyboardCustomInput.hasClass('has-focus') && !_this.$keyboardCustomInput.is(':focus'))) {
          var keyCode = e.keyCode || e.which;
          _this.keyDown(keyCode);
        }
      }
    });
  },

  //----------------------------------------------------------------------------

  buttonDown: function buttonDown($button) {
    var _this = this;

    var button = $button.data('button');
    _this.changeBtn(button, true);

    return _this;
  },

  keyDownKeyboardLayout: function keyDownKeyboardLayout(keyboardLayout, keyCode) {
    var _this = this;

    for (var btn in keyboardLayout) {
      if (btn && btn in keyboardLayout) {
        if ($.inArray(keyCode, keyboardLayout[btn].code) >= 0) {
          var value = String.fromCharCode((96 <= keyCode && keyCode <= 105) ? keyCode - 48 : keyCode);

          _this.changeBtn('btnDirectInput', false, value);
          return true;
        }
      }
    }

    return false;
  },

  keyDown: function keyDown(keyCode) {
    var _this = this;

    if (keyCode === 13) {
      _this.changeBtn('btnEnter', false, '');

      return _this;
    }

    if (keyCode === 8) {
      _this.changeBtn('btnBackspace', false, '');

      return _this;
    }

    if (keyCode === 32) {
      _this.changeBtn('btnSpace', false, ' ');

      return _this;
    }

    if (_this.layout === 'numeric' || _this.isAllowedSwitchLayout) {
      if (_this.keyDownKeyboardLayout(_this.numericLayout, keyCode)) {
        return _this;
      }
    }

    if (_this.layout === 'alphabet' || _this.isAllowedSwitchLayout) {
      if (_this.keyDownKeyboardLayout(_this.alphabetLayout, keyCode)) {
        return _this;
      }
    }

    return _this;
  },

  changeBtn: function changeBtn(button, virtualButton, char) {
    var _this = this;

    if (button === 'btnCE') {
      _this.setValue('');
      return;
    }

    if (button in _this.customButtons) {
      _this.changeCustomBtn(button);
      return;
    }

    if (button === 'btnEnter') {
      var e = $.Event('keydown', {
        originalEvent: {
          keyCode: 13,
          which: 13
        }
      });

      try {
        _this.$keyboardInput.trigger(e);
      } catch (e) {
        //musim odchytnout chybu, aby se nepodilal email
        return e;
      }

      return;
    }

    if (button === 'btnSpace') {
      if (_this.isAllowedSpace) {
        _this.confirmInputValue();
        _this.appendInputValue(' ');
        _this.confirmInputValue();
      }

      return;
    }

    if (button === 'btnBackspace') {
      _this.removeLastChar();
      _this.confirmInputValue();
      return;
    }

    if (button === 'btnShift') {
      _this.changeShift();
      return;
    }

    if (button === 'btnSwitch') {
      _this.swithLayout();
      return;
    }

    if (button === 'btnDirectInput') {
      _this.confirmInputValue();
      _this.appendInputValue(char);
      _this.confirmInputValue();
    }

    if (button in _this.keyboardLayout) {
      clearTimeout(_this.confirmTimeout);

      if (virtualButton) {
        char = _this.getSelectedChar(button);
      } else {
        _this.confirmInputValue();
      }

      _this.appendInputValue(char);

      if (virtualButton) {
        _this.confirmTimeout = setTimeout(function () {
          _this.confirmInputValue();
        }, _this.confirmDelay);
      } else {
        _this.confirmInputValue();
      }
    }

    return _this;
  },

  getSelectedChar: function getSelectedChar(button) {
    var _this = this;

    if (_this.lastClickedButton !== button) {
      _this.confirmInputValue();
    }

    _this.lastClickedButton = button;
    _this.lastClickedButtonIndex++;

    var layoutButton = _this.keyboardLayout[_this.lastClickedButton];
    if (layoutButton.code.length === 1) {
      _this.confirmInputValue();
      _this.lastClickedButtonIndex = 0;
    } else {
      if (_this.lastClickedButtonIndex === layoutButton.code.length)  {
        _this.lastClickedButtonIndex = 0;
      }
    }

    return layoutButton.title.substring(_this.lastClickedButtonIndex, _this.lastClickedButtonIndex + 1);
  },

  removeLastChar: function removeLastChar() {
    var _this = this;

    var currValue = _this.getInput().val();
    if (!isEmpty(currValue)) {
      currValue = currValue.substring(0, currValue.length - 1);
      _this.getInput().val(currValue);
      _this.getInput().change();
    }

    return _this;
  },

  changeShift: function changeShift() {
    var _this = this;

    _this.isShiftActivated = !_this.isShiftActivated;
    _this.changeKeyboardCase(_this.isShiftActivated);

    return _this;
  },

  swithLayout: function swithLayout() {
    var _this = this;

    if (_this.layout === 'alphabet') {
      _this.setLayout('numeric', _this.isAllowedSwitchLayout);
    } else {
      _this.setLayout('alphabet', _this.isAllowedSwitchLayout);
    }

    return _this;
  },

  changeCustomBtn: function changeCustomBtn(button) {
    var _this = this;

    if (button in _this.customButtons) {
      var btn = _this.customButtons[button];

      if (_this.isAllowedAppendCustomButtonValue) {
        _this.appendValue(btn.title, false, true);
      } else {
        _this.setValue(btn.title);
      }
    }

    return _this;
  },

  changeKeyboardCase: function changeKeyboardCase(upperCase) {
    var _this = this;

    if (_this.layout === 'alphabet') {
      var btnIndex = 1;

      for (var i = 0; i < 4; i++) {
        for (var j = 0; j < 3; j++) {
          var $button = _this.$keyboard.find('[data-button="btn' + btnIndex + '"]');
          var text = $button.text();
          if (upperCase) {
            $button.text(text.toUpperCase());
          } else {
            $button.text(text.toLowerCase());
          }

          btnIndex++;
        }
      }
    }

    return _this;
  },

  setIsAllowedSwitchLayout: function setIsAllowedSwitchLayout(allowSwitchLayout) {
    var _this = this;

    _this.isAllowedSwitchLayout = allowSwitchLayout;
    _this.$keyboard.removeClass('k2-keyboard--switch');

    if (_this.isAllowedSwitchLayout) {
      _this.$keyboard.addClass('k2-keyboard--switch');
    }

    return _this;
  },

  disableSpaceBtn: function disableSpaceBtn() {
    var _this = this;

    _this.$keyboard.find('.k2-keyboard__btn--space').hide();
    _this.isAllowedSpace = false;

    return _this;
  },

  enableSpaceBtn: function enableSpaceBtn() {
    var _this = this;

    _this.$keyboard.find('.k2-keyboard__btn--space').show();
    _this.isAllowedSpace = true;

    return _this;
  },

  //----------------------------------------------------------------------------

  appendInputValue: function appendInputValue(value, clearInput, maintainCase) {
    var _this = this;

    var currValue = '';

    if (!clearInput) {
      currValue = _this.getInput().data('value');

      if (isEmpty(currValue)) {
        currValue = '';
      }
    }

    if (!maintainCase) {
      if (_this.isShiftActivated) {
        value = value.toUpperCase();
      } else {
        value = value.toLowerCase();
      }
    }

    _this.getInput().val(currValue + value);
    _this.getInput().change();

    return _this;
  },

  confirmInputValue: function confirmInputValue() {
    var _this = this;

    _this.getInput().data('value', _this.getInput().val());
    _this.lastClickedButton = null;
    _this.lastClickedButtonIndex = -1;
    clearTimeout(_this.confirmTimeout);

    return _this;
  },

  getValue: function getValue() {
    var _this = this;

    return _this.getInput().val();
  },

  setValue: function setValue(value) {
    var _this = this;

    _this.appendInputValue(value, true, true);
    _this.confirmInputValue();

    return _this;
  },

  appendValue: function appendValue(value) {
    var _this = this;

    _this.appendInputValue(value, false, true);
    _this.confirmInputValue();

    return _this;
  },

  //----------------------------------------------------------------------------

  hideInput: function hideInput() {
    var _this = this;

    _this.$keyboardInputWrapper.hide();

    return _this;
  },

  showInput: function showInput() {
    var _this = this;

    _this.$keyboardInputWrapper.show();

    return _this;
  },

  focusInput: function focusInput() {
    var _this = this;

    _this.$keyboardInput.focus();

    return _this;
  },

  setCustomInput: function setCustomInput($input) {
    var _this = this;

    _this.$keyboardCustomInput = $input;

    return _this;
  },

  getInput: function getInput() {
    var _this = this;

    if (_this.$keyboardCustomInput) {
      return _this.$keyboardCustomInput;
    }

    return _this.$keyboardInput;
  },

  setInputSuffix: function setInputSuffix(suffix) {
    var _this = this;

    _this.$keyboard.find('.input-group-wrapper').addClass('input-group');
    _this.$keyboard.find('.input-suffix').removeClass('hidden');
    _this.$keyboard.find('.input-suffix').text(suffix);

    return _this;
  },

  setPlaceholder: function setPlaceholder(placeholder) {
    var _this = this;

    _this.$keyboardInput.attr('placeholder', placeholder);

    return _this;
  },

  setVirtualFocus: function setVirtualFocus() {
    var _this = this;

    _this.$keyboardInput.addClass('has-focus');

    return _this;
  },

  removeVirtualFocus: function removeVirtualFocus() {
    var _this = this;

    _this.$keyboardInput.removeClass('has-focus');

    return _this;
  },

  setInputType: function setInputType(type) {
    var _this = this;

    _this.$keyboardInput.attr('type', type);

    return _this;
  },

  //----------------------------------------------------------------------------

  reset: function () {
    var _this = this;

    _this.$keyboard.find('.input-group-wrapper').removeClass('input-group');
    _this.$keyboard.find('.input-suffix').addClass('hidden');
    _this.$keyboard.find('.input-suffix').text('');

    _this.$keyboardInput.val('');
    _this.$keyboardInput.attr('placeholder', '');
    _this.$keyboardInput.change();

    _this.setLayout('numeric');
    _this.changeKeyboardCase(false);
    _this.disableSpaceBtn();
    _this.addCustomButtons({});
    _this.$keyboardCustomInput = null;
    _this.setInputType('text');
    _this.showInput();

    return _this;
  },

  //----------------------------------------------------------------------------

  setLayout: function setLayout(layout, isAllowedSwitchLayout) {
    var _this = this;

    _this.$keyboard.removeClass('k2-keyboard--' + _this.layout);

    _this.layout = layout;

    switch (_this.layout) {
      case 'numeric': _this.keyboardLayout = _this.numericLayout; break;
      case 'alphabet': _this.keyboardLayout = _this.alphabetLayout; break;
    }

    _this.$keyboard.addClass('k2-keyboard--' + _this.layout);
    _this.initLayout(_this.keyboardLayout);
    _this.setIsAllowedSwitchLayout(isAllowedSwitchLayout);
    _this.changeKeyboardCase(_this.isShiftActivated);

    return _this;
  },

  initLayout: function initLayout(layout) {
    var _this = this;

    for (var btn in layout) {
      if (btn in layout) {
        var title = layout[btn].title;

        if (title === ' ') {
          title = ',_,';
        }

        _this.$keyboard.find('.btn[data-button="' + btn + '"]').text(title);
      }
    }

    return _this;
  },

  //----------------------------------------------------------------------------

  addCustomButtons: function addCustomButtons(buttons) {
    var _this = this;

    _this.customButtons = buttons;

    var $customButtons = _this.$keyboard.find('.k2-keyboard__custom-buttons');
    $customButtons.empty();

    for (var btnId in _this.customButtons) {
      if (btnId in _this.customButtons) {
        var btn = _this.customButtons[btnId];

        var btnClass = '';
        for (var index in btn.layout) {
          if (index in btn.layout) {
            btnClass += ' k2-keyboard__btn--' + btn.layout[index];
          }
        }

        var $btn = '<button class="btn btn-info k2-keyboard__btn k2-keyboard__btn--xs ' + btnClass + '" data-button="' + btnId + '">' + btn.title + '</button>';
        $customButtons.append($btn);
      }
    }

    return _this;
  },

  getKeyboard: function getKeyboard() {
    var _this = this;

    return _this.$keyboard;
  },

  initKeyboard: function initKeyboard() {
    var _this = this;

    _this.$keyboardInput = $('<input type="text" class="form-control" />');

    var keyboard = '';
    keyboard += '<div class="k2-keyboard k2-keyboard--' + _this.layout + '" id="' + _this.keyboardId + '">';
    keyboard +=   '<div class="k2-keyboard__input-wrapper">';
    keyboard +=     '<div class="input-group-wrapper">';
    keyboard +=       '<div class="input-group-addon input-suffix hidden"></div>';
    keyboard +=     '</div>';
    keyboard +=   '</div>';
    keyboard +=   '<div class="k2-keyboard__buttons">';

    keyboard +=     '<div class="row">';
    keyboard +=       '<div class="col-xs-9">';

    var btnIndex = 1;
    for (var i = 0; i < 4; i++) {
      keyboard +=       '<div class="row">';
      for (var j = 0; j < 3; j++) {
        keyboard +=         '<div class="col-xs-4">';
        keyboard +=           '<button class="btn btn-info k2-keyboard__btn" data-button="btn' + btnIndex + '">btn' + btnIndex + '</button>';
        keyboard +=         '</div>';

        btnIndex++;
      }

      keyboard +=       '</div>';
    }

    keyboard +=         '<div class="row">';
    keyboard +=           '<div class="col-xs-12">';
    keyboard +=             '<button class="btn btn-info k2-keyboard__btn k2-keyboard__btn--space" data-button="btnSpace">___</button>';
    keyboard +=           '</div>';
    keyboard +=         '</div>';

    keyboard +=       '</div>';
    keyboard +=       '<div class="col-xs-3">';
    keyboard +=         '<button class="btn btn-info k2-keyboard__btn" data-button="btnCE">CE</button>';
    keyboard +=         '<div class="k2-keyboard__custom-buttons"></div>';
    keyboard +=         '<button class="btn btn-info k2-keyboard__btn k2-keyboard__btn--xs k2-keyboard__btn--alphabet" data-button="btnBackspace">&lt;---</button>';
    keyboard +=         '<button class="btn btn-info k2-keyboard__btn k2-keyboard__btn--xs k2-keyboard__btn--alphabet" data-button="btnShift">a..z / A..Z</button>';
    keyboard +=         '<button class="btn btn-info k2-keyboard__btn k2-keyboard__btn--xs k2-keyboard__btn--switch" data-button="btnSwitch">1..9 / a..z</button>';
    keyboard +=         '<div class="k2-keyboard__custom-content"></div>';
    keyboard +=       '</div>';
    keyboard +=     '</div>';
    keyboard +=   '</div>';
    keyboard += '</div>';

    _this.$keyboard = $(keyboard);
    _this.$keyboard.find('.input-group-wrapper').prepend(_this.$keyboardInput);
    _this.$keyboardInputWrapper = _this.$keyboard.find('.k2-keyboard__input-wrapper');

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();
    _this.initKeyboard();
    _this.setLayout('numeric');
    _this.showInput();

    return _this;
  }
});
